import { useState, useCallback } from "react";
import HeroAnimation from "@/components/HeroAnimation";
import Navbar from "@/components/Navbar";
import BrandCarousel from "@/components/BrandCarousel";
import TopProducts from "@/components/TopProducts";
import BrandsSection from "@/components/BrandsSection";
import AboutSection from "@/components/AboutSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

const Index = () => {
  const [navVisible, setNavVisible] = useState(true);

  const handleNavVisible = useCallback((visible: boolean) => {
    setNavVisible(visible);
  }, []);

  return (
    <main className="bg-background">
      <Navbar visible={navVisible} />
      <HeroAnimation onNavVisible={handleNavVisible} />
      <BrandCarousel />
      <TopProducts />
      <BrandsSection />
      <AboutSection />
      <ContactSection />
      <Footer />
    </main>
  );
};

export default Index;
